/**
 * Grammatik's exercise card.
 *
 * The faces themselves are shared with Gramática — see
 * `src/apps/shared/grammar/CardFront.tsx`. This file supplies the adapter and
 * the course, so a fix to how an exercise is drilled lands in both languages.
 */
import { useEffect, useRef } from 'react';

import { GrammarCardFront } from '../shared/grammar/CardFront';
import type { CardFrontProps } from '../types';

import { grammatikCourse, toExercise } from './course';
import type { GrammatikPayload } from './types';

export function CardFront({ card, onAnswer }: CardFrontProps<GrammatikPayload>) {
  const startRef = useRef<number>(Date.now());

  useEffect(() => {
    startRef.current = Date.now();
  }, [card.id]);

  return (
    <GrammarCardFront
      exercise={toExercise(card.payload)}
      course={grammatikCourse}
      cardKey={card.id}
      onAnswer={(correct, userAnswer) =>
        onAnswer({ correct, user_answer: userAnswer, time_ms: Date.now() - startRef.current })
      }
    />
  );
}
